import { Layers } from "lucide-react"
import type { IDTEFSourcesSummary } from "@/@types/dtef-payment"

interface DtefSourcesWarningProps {
  sources: IDTEFSourcesSummary | undefined
}

const formatImportedAt = (value: string | null) =>
  value
    ? new Date(value).toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "data desconhecida"

export const DtefSourcesWarning = ({ sources }: DtefSourcesWarningProps) => {
  if (!sources) return null
  if (!sources.has_multiple_sources && !sources.has_unbatched_rows) return null

  return (
    <div className="flex gap-3 rounded-md border border-amber-300 bg-amber-50 p-3 lg:col-span-2">
      <Layers className="h-5 w-5 text-amber-600 shrink-0" />
      <div className="flex flex-col gap-1 text-sm text-amber-800">
        <p className="font-semibold">
          Os valores abaixo somam {sources.source_count} origens diferentes.
        </p>
        <p>
          Excluir um arquivo remove apenas a parte dele. As demais origens
          continuam somando nesta conciliação.
        </p>
        <ul className="list-disc pl-4">
          {sources.batches.map((batch) => (
            <li key={batch.batch_id}>
              {batch.file_name ?? "arquivo não identificado"} —{" "}
              {formatImportedAt(batch.imported_at)}
              {batch.imported_by ? ` por ${batch.imported_by}` : ""} (
              {batch.row_count} registros)
            </li>
          ))}
          {sources.has_unbatched_rows && (
            <li>
              Registros anteriores ao controle por lote —{" "}
              {sources.unbatched_row_count} registros, não removíveis pela tela
              de importação.
            </li>
          )}
        </ul>
      </div>
    </div>
  )
}
